











































import {
  computed,
  defineComponent, ref, useContext, useFetch,
} from '@nuxtjs/composition-api';

import getJobs from "~/customQueries/queries/getJobs.gql";
import Newsletter from "~/components/Palmers/Newsletter.vue";
import {getMetaInfoVuePages} from "~/helpers/getMetaInfo";
import {useUrl} from "~/composables/Palmers";

export default defineComponent({
  name: 'JobsList',
  components: {
    Newsletter
  },
  setup() {
    const loaded = ref(false);
    const {$vsf} = useContext();
    const jobs = ref({
      items: []
    })

    const {getMediaUrl} = useUrl();


    useFetch(async () => {
      //@ts-ignore
      const {getJobs} = (await $vsf.$magento.api.getJobs()).data;

      jobs.value = getJobs || {items: []};

      loaded.value = true;
    });

    let palmersJobs = computed(() => jobs.value);

    return {
      getMediaUrl,
      palmersJobs,
      loaded,
      meta: getMetaInfoVuePages({
        title: 'Palmers Jobs'
      })
    }
  },
  head() {
    return this.meta;
  },
  methods: {
    extractValue(value) {
      const match = value.match(/href='(.*?)'/);
      if (match && match[1]) {
        return match[1];
      } else {
        return false;
      }
    },
  }
});
